<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- <div v-if="isShow">
            <van-empty image="error" description="不存在表决事项或尚未绑定房屋。" />
            <a href="">立即绑定房屋</a>
        </div> -->
        <div v-if="isShow">
            <van-empty description="不存在表决事项或尚未绑定房屋。">
                <span style="font-size:14px;color:blue" @click="openHouses">立即绑定房屋</span>
                <!-- <van-button round type="danger" class="bottom-button">按钮</van-button> -->
            </van-empty>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-bottom:100px">
            <van-list style="margin-bottom:40px" v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad" >
                <div :class="item.voteState=='4'?'MyCard1':'MyCard'" v-for="item in list" :key="item" @click="openMyVote(item)">
                    <van-col span='24' style="font-size:14px;font-weight:bold">{{item.reqName}}---<span style="font-size:12px;color:gray;font-weight:normal">{{item.startPublicityDate}}</span></van-col>
                    <van-col span='24' style="font-size:13px;margin-top:6px">申请单位：{{item.orgType=='1'?item.orgName:item.orgType=='2'?item.ownerCommitteeName:''}}</van-col>
                    <!-- <van-col :class="item.opinion=='0'?'mySon1':item.opinion=='1'?'mySon2':item.opinion=='2'?'mySon3':item.opinion=='3'?'mySon4':'mySon5'" span='24' style="font-size:22px;font-weight:bold;text-align:center;margin:13px 0">{{item.opinion=='0'?'同意':item.opinion=='1'?'不同意':item.opinion=='2'?'未表决':item.opinion=='3'?'弃权':'已过期'}}</van-col> -->
                    <van-col  span='24' style="font-size:22px;font-weight:bold;text-align:center;margin:13px 0">
                        <!-- {{item.voteState}} -->
                        <span v-if="item.opinion=='2'" :class="item.voteState=='1'?'mySon1':item.voteState=='2'?'mySon2':item.voteState=='3'?'mySon3':item.voteState=='4'?'mySon4':''">
                            {{item.voteState=='1'?'公示中':item.voteState=='2'?'待表决':item.voteState=='3'?'投票结束':item.voteState=='4'?'已过期':''}}
                        </span>
                        <span v-else :class="item.opinion!='2'?'mySon3':''">
                            {{item.opinion=='0'?'同意':item.opinion=='1'?'不同意':item.opinion=='3'?'弃权':''}}
                        </span>
                        <!-- <span v-if="item.voteState=='2'">待表决</span>
                        <span v-if="item.voteState=='3'">{{item.opinion=='0'?'同意':item.opinion=='1'?'不同意':item.opinion=='2'?'未表决':item.opinion=='0'?'弃权':''}}</span>
                        <span v-if="item.voteState=='4'">已过期</span> -->
                    </van-col>
                    <van-col span='24' style="font-size:13px;margin-bottom:6px">房屋坐落：{{item.houseSite}}</van-col>
                    <van-col span='24' style="font-size:13px">建筑面积(㎡)：{{item.struArea}}</van-col>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data(){
        return {
            isShow:false,
            refreshing:false,
            list:[],
            error: false,
            loading:false,
            finished:false,
        }
    },
    // beforeRouteLeave(to,from,next){
    //     if(to.name=='index'||to.name=='房屋管理'||to.name=='业主表决'){
    //         next(true)
    //     }else{
    //         next({path:'/'})
    //     }
    // },
    methods:{
        onLoad(){
            let data = {
                openId:VueCookie.get('openid'),
                // openId:'o5AgcxKDu14LYiSrhGBzj_rMu7ZM',
                pageNum:1,
                pageSize:100
            }
            this.$postQuery('/WeChat/getVoteListByOpenId', data)
            .then((response)=>{
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                // console.log(response)
                if(response.code==200){
                    this.list = response.data.list
                    if(this.list.length==0){
                        this.isShow = true
                    }
                    this.loading = false
                    if (this.list.length >= response.data.list.length) {
                        this.finished = true;
                    }
                }
            })
            .catch(()=>{
                this.loading = false
                this.error = true;
            })
        },
        onRefresh(){
            // 清空列表数据
            this.finished = false;
            //重新加载列表
            this.loading = true;
            this.onLoad();
        },
        openMyVote(item){
            // console.log({...item})
            this.$router.push({
                path:'/OwnersVoting',
                query:{
                    roomNo:item.roomNo,
                    reqId:item.reqId,
                    startPublicityDate:item.startPublicityDate,
                    voteState:item.voteState,
                    opinion1:item.opinion,
                    regionName:item.regionName
                }
            })
            // if(item.opinion=='5'){
            //     return
            // }else{
            //     this.$router.push({
            //         path:'/OwnersVoting'
            //     })
            // }
        },
        openHouses(){
            this.$router.replace({
            path:'/HousingManagement'
            })
        }
    }
}
</script>

<style scoped>
.list{
    margin-top:46px
}
.MyCard{
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    box-shadow: 0 8px 12px #ebedf0;
    margin: 13px;
    padding: 10px;
}
.mySon1{
    color: gray;
}
.mySon2{
    color: skyblue;
}
.mySon3{
    color: red;
}
.mySon4{
    color: gray;
}
.mySon5{
    color: gray;
}
.MyCard1{
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    box-shadow: 0 8px 12px #ebedf0;
    margin: 13px;
    padding: 10px;
    background-color: #e0e0e0;
}
</style>